import { atom } from 'jotai';

export const showDevToolsAtom = atom<'tanstackRouter' | 'tanstackQuery' | null>(null);
